var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkuDropdownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 3,
    viewBox: "0 0 11 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 1.5C0.75 1.08579 1.08579 0.75 1.5 0.75C1.91421 0.75 2.25 1.08579 2.25 1.5C2.25 1.91421 1.91421 2.25 1.5 2.25C1.08579 2.25 0.75 1.91421 0.75 1.5ZM1.72851e-07 1.5C1.3664e-07 0.671573 0.671573 -1.3664e-07 1.5 -1.72852e-07C2.32843 -2.09063e-07 3 0.671573 3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 2.09063e-07 2.32843 1.72851e-07 1.5Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2L4.5 2L4.5 1L2.5 1L2.5 2Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2L8.5 2L8.5 1L6.5 1L6.5 2Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 -1.72852e-07C4.67157 -1.3664e-07 4 0.671573 4 1.5C4 2.32843 4.67157 3 5.5 3C6.32843 3 7 2.32843 7 1.5C7 0.671573 6.32843 -2.09063e-07 5.5 -1.72852e-07Z",
    fill: "#2FA85F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 -1.72852e-07C8.67157 -1.3664e-07 8 0.671573 8 1.5C8 2.32843 8.67157 3 9.5 3C10.3284 3 11 2.32843 11 1.5C11 0.671573 10.3284 -2.09063e-07 9.5 -1.72852e-07Z",
    fill: "#2FA85F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkuDropdownIcon);
export default __webpack_public_path__ + "static/media/skuDropdownIcon.4c35ba2f7a5e50ba5867af4c761877ad.svg";
export { ForwardRef as ReactComponent };